import axios from 'axios';
import { motion } from 'framer-motion';
import mapboxgl from 'mapbox-gl';
import { useRef } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import projectData from '../data/projects';
import {
    ArrowRight,
    ChevronLeft,
    ChevronRight,
    Cpu,
    Settings,
    Shield,
    Zap
} from 'lucide-react';
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';
import { set } from 'date-fns';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN || 'your_mapbox_access_token_here';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const API = `${BACKEND_URL}/api`;




const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [statistics, setStatistics] = useState([]);
  const [projects, setProjects] = useState([]);
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const heroSlides = [
    {
      image:
        'https://images.unsplash.com/photo-1709131121922-028189a2c984?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxoeWRybyUyMHBvd2VyJTIwcGxhbnQlMjBkYW0lMjBzY2VuaWN8ZW58MHx8fHwxNzcwMjkyNTY1fDA&ixlib=rb-4.1.0&q=85',
      title: 'Engineering  Intelligence',
      subtitle: 'For Hydro Power'
    },
    {
      image:
        'https://images.unsplash.com/photo-1769697148689-4ae92b0d8848?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxoeWRybyUyMHBvd2VyJTIwcGxhbnQlMjBkYW0lMjBzY2VuaWN8ZW58MHx8fHwxNzcwMjkyNTY1fDA&ixlib=rb-4.1.0&q=85',
      title: 'From  Design',
      subtitle: 'To Commissioning'
    },
    {
    image: '/assets/slides/slide3.png',
    title: ' Monitoring  &  Control',
    subtitle: 'from  anywhere  &  anytime'
  }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchStatistics();
    setProjects(projectData);
    
  }, []);

useEffect(() => {

  if (!projects.length || mapRef.current) return;

  const map = new mapboxgl.Map({
    container: mapContainerRef.current,
    style: "mapbox://styles/mapbox/dark-v11",
    center: [84.5, 27],
    zoom: 5,          // ✅ Correct zoom
    pitch: 0,
    bearing: 0,
    antialias: true
  });

  map.on("load", () => {

    // Force flat projection
    map.setProjection("mercator");

    // Hydro dark styling
    map.setPaintProperty("background", "background-color", "#050a15");
    map.setPaintProperty("water", "fill-color", "#0a0f1a");
    map.setPaintProperty("water", "fill-opacity", 0.9);

    // Hide labels
    map.getStyle().layers.forEach((layer) => {
      if (
        layer.type === "symbol" &&
        layer.layout &&
        layer.layout["text-field"]
      ) {
        map.setLayoutProperty(layer.id, "visibility", "none");
      }
    });

    // Cinematic fog
    map.setFog({
      color: "rgb(5,10,20)",
      "high-color": "rgb(14,165,233)",
      "horizon-blend": 0.15,
      "space-color": "rgb(2,6,23)",
      "star-intensity": 0.15
    });

    // 🔷 Premium Turbine SVG
    const turbineSVG = `
      <svg width="22" height="22" viewBox="0 0 100 100">
        <defs>
          <linearGradient id="boltGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#fde68a"/>
            <stop offset="100%" stop-color="#f59e0b"/>
          </linearGradient>
        </defs>
        <path d="M55 8 L30 55 H48 L40 92 L75 42 H58 L65 8 Z"
              fill="url(#boltGrad)"/>
      </svg>
    `;

    // 🔷 Add Markers
    projects.forEach((project) => {
      if (!project.latitude || !project.longitude) return;

      const el = document.createElement("div");
      el.className = "hydro-marker";
      el.innerHTML = turbineSVG;

      const popup = new mapboxgl.Popup({ offset: 20 })
        .setHTML(`
          <div style="
            background:#0f172a;
            padding:14px;
            border-radius:10px;
            border:1px solid rgba(245,158,11,0.4);
            color:white;
            font-family:system-ui;
          ">
            <h3 style="color:#fde68a;margin-bottom:6px;">
              ${project.name}
            </h3>
            <p style="margin:0;font-size:13px;opacity:0.8;">
              ${project.location}
            </p>
            <div style="margin-top:6px;font-size:12px;color:#f59e0b;">
              ${project.capacity}
            </div>
          </div>
        `);

      new mapboxgl.Marker({
        element: el,
        anchor: "center"
      })
        .setLngLat([project.longitude, project.latitude])
        .setPopup(popup)
        .addTo(map);
    });

 // =============================
// 🎬 AUTO REGION CINEMATIC LOOP (SAFE VERSION)
// =============================

// Helper: create bounds from project array
function getBounds(projectArray) {
  const bounds = new mapboxgl.LngLatBounds();
  projectArray.forEach(p => {
    if (p.latitude && p.longitude) {
      bounds.extend([p.longitude, p.latitude]);
    }
  });
  return bounds;
}

// Define regions dynamically
const northProjects = projects.filter(
  p =>
    p.latitude &&
    p.longitude &&
    p.latitude > 28 &&
    p.latitude < 33 &&
    p.longitude > 75 &&
    p.longitude < 83
);

const northEastProjects = projects.filter(
  p =>
    p.latitude &&
    p.longitude &&
    p.latitude > 23 &&
    p.latitude < 29 &&
    p.longitude > 88 &&
    p.longitude < 97
);

const southProjects = projects.filter(
  p =>
    p.latitude &&
    p.longitude &&
    p.latitude < 18 &&
    p.longitude > 73 &&
    p.longitude < 82
);

// All India
const allProjects = projects.filter(
  p => p.latitude && p.longitude
);

// Build region bounds
const regionBounds = [
  { bounds: getBounds(northProjects), zoom: 6.2 },      // North
  { bounds: getBounds(northEastProjects), zoom: 11 },  // Northeast
  { bounds: getBounds(southProjects), zoom: 6.2 },      // South
  { bounds: getBounds(allProjects), zoom: 5.2 }         // India view
];

let regionIndex = 0;

function regionLoop() {

  const region = regionBounds[regionIndex];

  if (!region.bounds.isEmpty()) {

    map.fitBounds(region.bounds, {
      padding: {
        top: 160,
        bottom: 160,
        left: 180,
        right: 180
      },
      duration: 2600,
      essential: true,
      easing: (t) => t * (2 - t)   // smooth cinematic easing
    });

    // Only apply additional zoom for Northeast region
    if (regionIndex === 1) {

      map.once("moveend", () => {
        map.easeTo({
          zoom: map.getZoom() + 0.7,
          duration: 900,
          easing: (t) => t * (2 - t)
        });
      });

    }
  }

  regionIndex = (regionIndex + 1) % regionBounds.length;

  setTimeout(regionLoop, 5200);
}

// Start loop after initial load
setTimeout(regionLoop, 3000);
  });

  mapRef.current = map;

  return () => {
    map.remove();
    mapRef.current = null;
  };

}, [projects]);

  const fetchStatistics = async () => {
    try {
      const response = await axios.get(`${API}/statistics`);
      setStatistics(response.data);
    } catch (error) {
      console.error('Error fetching statistics:', error);
      setStatistics([
        { stat_id: '1', label: 'MW Installed', value: 10, suffix: '+', order: 1 },
        { stat_id: '2', label: 'Projects Executed', value: 125, suffix: '+', order: 2 },
        { stat_id: '3', label: 'Control Panels', value: 120, suffix: '+', order: 3 },
        { stat_id: '4', label: 'Years Experience', value: 20, suffix: '+', order: 4 }
      ]);
    }
  };



  const expertiseItems = [
    {
      icon: <Zap size={32} />,
      title: 'Hydro Power Plant Design',
      description: 'Complete electrical and control system design for small and medium hydro projects'
    },
    {
      icon: <Settings size={32} />,
      title: 'Control & Protection Panels',
      description: 'Custom-engineered panels built to utility standards with comprehensive protection schemes'
    },
    {
      icon: <Cpu size={32} />,
      title: 'Automation & SCADA',
      description: 'PLC-based automation with real-time monitoring and remote control capabilities'
    },
    {
      icon: <Shield size={32} />,
      title: 'Manufacturing & Testing',
      description: 'In-house manufacturing with rigorous factory acceptance testing protocols'
    }
  ];

  const processSteps = [
    'Concept & Design',
    'Manufacturing',
    'Factory Testing',
    'Installation',
    'Commissioning',
    'Support'
  ];

  const industries = [
    'Small & Medium Hydro',
    'Industrial Power Systems',
    'Renewable Energy Infrastructure',
    'Utility-Scale Control Systems'
  ];

  return (
    <div className="min-h-screen" data-testid="home-page">
      <section className="relative h-screen overflow-hidden" data-testid="hero-section">
        {heroSlides.map((slide, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: currentSlide === index ? 1 : 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0"
            style={{ pointerEvents: currentSlide === index ? 'auto' : 'none' }}
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url(${slide.image})`,
                transform: currentSlide === index ? 'scale(1.1)' : 'scale(1)',
                transition: 'transform 5s ease-out'
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/50 to-slate-950" />
          </motion.div>
        ))}

        <div className="relative h-full flex items-center justify-center text-center px-6">
          <div className="max-w-5xl">
            <motion.h1
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.2 }}
              className="font-heading font-semibold text-5xl md:text-7xl lg:text-8xl tracking-tighter text-slate-100 mb-6 drop-shadow-[0_6px_40px_rgba(0,0,0,0.9)]"
              data-testid="hero-title"
            >
              {heroSlides[currentSlide].title}
              <br />
              <span className="text-ocean-400 drop-shadow-[0_4px_24px_rgba(0,0,0,0.85)]">{heroSlides[currentSlide].subtitle}</span>
            </motion.h1>
            <motion.p
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.4 }}
              className="text-lg md:text-xl text-slate-300 mb-12 max-w-2xl mx-auto"
            >
              Leading provider of electrical control systems, automation solutions, and comprehensive
              project execution for hydro power plants
            </motion.p>
            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <Link
                to="/projects"
                data-testid="hero-cta-projects"
                className="px-8 py-4 bg-ocean-500 hover:bg-ocean-600 text-white font-medium uppercase tracking-widest text-xs transition-all inline-flex items-center justify-center gap-2"
              >
                View Our Projects
                <ArrowRight size={16} />
              </Link>
              <Link
                to="/contact"
                data-testid="hero-cta-contact"
                className="px-8 py-4 border border-white/20 hover:border-white text-white font-medium uppercase tracking-widest text-xs transition-all inline-flex items-center justify-center"
              >
                Contact Us
              </Link>
            </motion.div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              data-testid={`hero-slide-indicator-${index}`}
              className={`w-12 h-1 transition-all ${
                currentSlide === index ? 'bg-ocean-500' : 'bg-white/30'
              }`}
            />
          ))}
        </div>

        <button
          onClick={() => setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
          data-testid="hero-prev-slide"
          className="absolute left-8 top-1/2 -translate-y-1/2 w-12 h-12 border border-white/20 hover:border-white hover:bg-white/10 text-white transition-all flex items-center justify-center"
        >
          <ChevronLeft size={24} />
        </button>
        <button
          onClick={() => setCurrentSlide((prev) => (prev + 1) % heroSlides.length)}
          data-testid="hero-next-slide"
          className="absolute right-8 top-1/2 -translate-y-1/2 w-12 h-12 border border-white/20 hover:border-white hover:bg-white/10 text-white transition-all flex items-center justify-center"
        >
          <ChevronRight size={24} />
        </button>
      </section>

      <section className="py-24 bg-slate-900" data-testid="about-snapshot-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white mb-8">
              Engineering Partner for <span className="text-ocean-500">Hydro Power</span>
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-slate-400 mb-6">
              Ytek Controls specializes in the design, manufacturing, and commissioning of Hydro Turbines and electrical
              control systems for hydro power plants. Our engineering-first approach ensures reliable,
              standards-compliant solutions that deliver lasting value.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-slate-500">
              From concept to commissioning, we bring technical expertise, precision manufacturing,
              and unwavering commitment to every project.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-950" data-testid="statistics-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {statistics.map((stat) => (
              <div key={stat.stat_id} className="text-center" data-testid={`stat-card-${stat.label}`}>
                <div className="font-heading text-6xl md:text-7xl font-light text-ocean-500 mb-2">
                  <CountUp end={stat.value} duration={2.5} separator="," />
                  {stat.suffix}
                </div>
                <div className="text-sm md:text-base uppercase tracking-wider text-slate-400">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-900" data-testid="expertise-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white mb-16 text-center">
            Core Expertise
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {expertiseItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                data-testid={`expertise-card-${index}`}
                className="bg-slate-900/50 border border-white/5 p-8 hover:border-ocean-500/30 transition-all group"
              >
                <div className="text-ocean-500 mb-4">{item.icon}</div>
                <h3 className="font-heading text-2xl font-semibold text-white mb-3">{item.title}</h3>
                <p className="text-slate-400 leading-relaxed">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-950" data-testid="process-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white mb-16 text-center">
            Engineering Process
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
            {processSteps.map((step, index) => (
              <div key={index} className="text-center" data-testid={`process-step-${index}`}>
                <div className="w-16 h-16 mx-auto mb-4 border-2 border-ocean-500 flex items-center justify-center font-mono text-xl text-ocean-500">
                  {index + 1}
                </div>
                <p className="text-sm uppercase tracking-wider text-slate-400">{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-900" data-testid="design-showcase-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white mb-6">
                Design Excellence
              </h2>
              <p className="text-lg text-slate-400 mb-8 leading-relaxed">
                Our design capabilities span the complete spectrum of hydro power systems. From turbine
                selection and optimization to custom control panel layouts, we engineer solutions that
                maximize efficiency and reliability.
              </p>
              <Link
                to="/design"
                data-testid="design-cta-link"
                className="px-8 py-4 bg-ocean-500 hover:bg-ocean-600 text-white font-medium uppercase tracking-widest text-xs transition-all inline-flex items-center gap-2"
              >
                Explore Our Design Work
                <ArrowRight size={16} />
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.unsplash.com/photo-1759159091682-3b98f4759367?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwY29udHJvbCUyMHBhbmVsJTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3NzAyOTI1ODN8MA&ixlib=rb-4.1.0&q=85"
                alt="Industrial machinery"
                className="w-full h-64 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1758873263914-230f8ff60569?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwY29udHJvbCUyMHBhbmVsJTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3NzAyOTI1ODN8MA&ixlib=rb-4.1.0&q=85"
                alt="Control panel"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>
        </div>
      </section>
      <section
  className="py-24 bg-slate-950"
  data-testid="project-map-section"
>
  <div className="max-w-7xl mx-auto px-6 md:px-12">
    
    <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white mb-16 text-center">
      Our Project Footprint
    </h2>

    <div className="relative h-[600px] rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_80px_rgba(14,165,233,0.15)]">
      
      <div
        ref={mapContainerRef}
        className="w-full h-full"
      />

      {/* Top Gradient Blend */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-slate-950 to-transparent pointer-events-none" />

      {/* Bottom Gradient Blend */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-slate-950 to-transparent pointer-events-none" />

    </div>

  </div>
</section>

      <section className="py-24 bg-slate-950" data-testid="excellent-numbers-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-white mb-20 text-center">
            Our <span className="text-ocean-500">Excellent Numbers</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="text-center" data-testid="excellent-stat-projects">
              <div className="font-heading text-5xl md:text-6xl font-light text-ocean-500 mb-3">
                <CountUp end={150} duration={3} separator="," />+
              </div>
              <div className="text-sm md:text-base uppercase tracking-wider text-slate-400 leading-tight">
                Successful<br />Projects
              </div>
            </div>

            <div className="text-center" data-testid="excellent-stat-experience">
              <div className="font-heading text-5xl md:text-6xl font-light text-ocean-500 mb-3">
                <CountUp end={20} duration={3} />+
              </div>
              <div className="text-sm md:text-base uppercase tracking-wider text-slate-400 leading-tight">
                Years of Unparalleled<br />Industry Experience
              </div>
            </div>

            <div className="text-center" data-testid="excellent-stat-states">
              <div className="font-heading text-5xl md:text-6xl font-light text-ocean-500 mb-3">
                <CountUp end={15} duration={3} />+
              </div>
              <div className="text-sm md:text-base uppercase tracking-wider text-slate-400 leading-tight">
                States<br />Covered
              </div>
            </div>

            <div className="text-center" data-testid="excellent-stat-capacity">
              <div className="font-heading text-5xl md:text-6xl font-light text-ocean-500 mb-3">
                <CountUp end={5} duration={3} /> MW
              </div>
              <div className="text-sm md:text-base uppercase tracking-wider text-slate-400 leading-tight">
                Manufacturing<br />Capabilities
              </div>
            </div>

            <div className="text-center" data-testid="excellent-stat-efficiency">
              <div className="font-heading text-5xl md:text-6xl font-light text-ocean-500 mb-3">
                <CountUp end={92} duration={3} />%
              </div>
              <div className="text-sm md:text-base uppercase tracking-wider text-slate-400 leading-tight">
                Most Efficient<br />Turbine Systems
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-900" data-testid="industries-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white mb-16 text-center">
            Industries We Serve
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {industries.map((industry, index) => (
              <div
                key={index}
                data-testid={`industry-card-${index}`}
                className="bg-slate-900/50 border border-white/5 p-6 hover:border-ocean-500/30 transition-all"
              >
                <p className="text-lg font-medium text-white">{industry}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1769697148689-4ae92b0d8848?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxoeWRybyUyMHBvd2VyJTIwcGxhbnQlMjBkYW0lMjBzY2VuaWN8ZW58MHx8fHwxNzcwMjkyNTY1fDA&ixlib=rb-4.1.0&q=85)'
        }}
        data-testid="cta-section"
      >
        <div className="absolute inset-0 bg-slate-950/80" />
        <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-heading text-4xl md:text-6xl font-light tracking-tighter text-white mb-8">
            Let's Engineer Your Next Power Project
          </h2>
          <Link
            to="/contact"
            data-testid="cta-contact-button"
            className="px-8 py-4 bg-ocean-500 hover:bg-ocean-600 text-white font-medium uppercase tracking-widest text-xs transition-all inline-flex items-center gap-2"
          >
            Get In Touch
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
